import { useBlocNext } from "@blac/react";
import { AuthenticationMethod } from "src/ui/components/WithAuth/WithAuthCubit";
import UserCubit from "src/state/UserCubit/UserCubit";
import UserPreferencesCubit from "src/state/UserPreferencesCubit/UserPreferencesCubit";
import { useBloc } from "src/state/state";

export interface SsoLockedFieldsResult {
  isTranscarentSso: boolean;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
}

/**
 * Returns Transcarent SSO status and user preference values that may be used
 * to lock intake funnel fields. The consumer (e.g. DynamicInput) decides which
 * fields to lock based on data presence — inputs themselves stay generic.
 */
const useSsoLockedFields = (): SsoLockedFieldsResult => {
  const [{ userData }] = useBloc(UserCubit);
  const [, { firstName, lastName, dateOfBirth }] =
    useBlocNext(UserPreferencesCubit);

  const isTranscarentSso =
    userData?.sessionAuthenticationMethod ===
    AuthenticationMethod.TRANSCARENT_SSO;

  return { isTranscarentSso, firstName, lastName, dateOfBirth };
};

export default useSsoLockedFields;
